<div class="rate-card-list">
  <mat-form-field>
    <mat-label>{{title}}</mat-label>
    <mat-select [formControl]="formControl" [compareWith]="compareWith">
      @for (value of values; track value) {
        <mat-option [value]="value">
          {{value.Name}}
        </mat-option>
      }
    </mat-select>
    @for (errorKey of errorKeys(formControl); track errorKey) {
      <mat-error>
        @if (formControl.touched && formControl.hasError(errorKey)) {
          {{errorMessage(formControl, errorKey)}}
        }
      </mat-error>
    }
  </mat-form-field>
</div>
